"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfigService = void 0;
var app_1 = require("app");
var ConfigService = /** @class */ (function () {
    function ConfigService() {
    }
    ConfigService.prototype.GetData = function () {
        this.config = this.config || app_1.AttrService.data(document.body, 'config');
        return this.config;
    };
    ConfigService.prototype.GetIPaperDomain = function () {
        var config = this.config || this.GetData();
        if (!config || !config.iPaperDomain) {
            return;
        }
        return config.iPaperDomain;
    };
    ConfigService.prototype.IsDeferOffscreenImagesEnabled = function () {
        var config = this.config || this.GetData();
        if (!config || !config.isDeferOffscreenImagesEnabled) {
            return false;
        }
        return config.isDeferOffscreenImagesEnabled;
    };
    return ConfigService;
}());
var service = new ConfigService();
exports.ConfigService = service;
